import { useMutation } from '@tanstack/react-query'

import type { ApiError } from '@/lib/api/errors'
import { submitOperationVerification } from '@/lib/venue/operationVerificationApi'
import type { OperationVerificationSubmitInput, OperationVerificationView } from '@/lib/venue/operationVerificationTypes'

/**
 * EP-1 — 운영 인증 신청 제출(`#772`, 백엔드 `#771` §2).
 *
 * 🚨 성공 응답을 캐시에 반영하지 않는다 — 이 화면은 성공 시 같은 페이지의 로컬 상태로 "제출 완료"
 * 화면을 그리고, 재신청 prefill 쿼리는 **재조회하지 않는다**(api-spec §171 "제출 직후 재조회하지
 * 말 것 — Reader 복제 지연 때문에 옛 값이 보인다").
 */
export function useSubmitOperationVerification(venueId: string) {
  return useMutation<OperationVerificationView, ApiError, OperationVerificationSubmitInput>({
    mutationFn: (input) => submitOperationVerification(venueId, input),
  })
}
